exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-srwoodworks-index-tsx": () => import("./../../../src/pages/srwoodworks/index.tsx" /* webpackChunkName: "component---src-pages-srwoodworks-index-tsx" */),
  "component---src-pages-srwoodworks-sr-woodworks-tsx": () => import("./../../../src/pages/srwoodworks/SrWoodworks.tsx" /* webpackChunkName: "component---src-pages-srwoodworks-sr-woodworks-tsx" */)
}

